<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Hard Seltzer Cocktail Book, by Casie Vogel" aria-describedby="cover-alt" class="imagefp" epub:type="cover" role="doc-cover" src="e9781646042197/images/9781646042197.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>The Hard Seltzer Cocktail Book</p>
<p>55 Unofficial Recipes for White ClawⓇ Slushies, TrulyⓇ Mixers, and More
            Spiked-Seltzer Drinks</p>
<p>Casie Vogel</p>
<p>Independently Authored and Published</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?479aeeb8